class SplideComponent extends HTMLElement {
  constructor() {
    super();

    this.arrows = this.querySelector(".splide__arrows");
    this.pagination = this.querySelector(".splide__pagination");
    this.progressBar = this.querySelector(".splide__progress-bar");
    this.splideElement = this.querySelector(".splide");

    this.defaults = {
      type: "slide",
      pagination: false,
      arrows: false,
      focus: 0,
      omitEnd: true,
      flickPower: 500,
      speed: 1200,
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const options = {
      ...this.defaults,
    };

    this.splide = new Splide(this.splideElement, options);

    if (this.arrows) {
      this.splide.options.arrows = true;
    }

    if (this.pagination) {
      this.splide.options.pagination = true;
    }

    if (this.progressBar) {
      this.splide.on("mounted move", () => {
        const end = this.splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((this.splide.index + 1) / end, 1);
        this.progressBar.style.width = String(100 * rate) + "%";
      });
    }

    this.splide.mount();
  }
}

if (!customElements.get("splide-component")) {
  customElements.define("splide-component", SplideComponent);
}
